module.exports = __webpack_public_path__ + "img/ANTENNA 3 PURPLE.fa225b7.svg";